import { dismiss } from '@atlassian/jira-flags/src/services/store/constants';
import { getFlags } from '@atlassian/jira-flags/src/services/store/selectors';
import type { State } from '@atlassian/jira-flags/src/services/store/types';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import Flags from './main.tsx';
import { PropBypass } from './props-bypass/index.tsx';

export default connect(
	(state: State) => ({
		flags: getFlags(state),
		PropBypass,
	}),
	{
		onDismissed: dismiss,
	},
)(Flags);
